'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderFormFields = exports.renderInput = undefined;

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _sortBy = require('lodash/sortBy');

var _sortBy2 = _interopRequireDefault(_sortBy);

var _values = require('lodash/values');

var _values2 = _interopRequireDefault(_values);

var _inputDate = require('constructicon/input-date');

var _inputDate2 = _interopRequireDefault(_inputDate);

var _inputField = require('constructicon/input-field');

var _inputField2 = _interopRequireDefault(_inputField);

var _inputSearch = require('constructicon/input-search');

var _inputSearch2 = _interopRequireDefault(_inputSearch);

var _inputSelect = require('constructicon/input-select');

var _inputSelect2 = _interopRequireDefault(_inputSelect);

var _label = require('constructicon/label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderInput = exports.renderInput = function renderInput(type) {
  switch (type) {
    case 'date':
      return _inputDate2.default;
    case 'search':
      return _inputSearch2.default;
    case 'select':
      return _inputSelect2.default;
    case 'label':
      return _label2.default;
    default:
      return _inputField2.default;
  }
};

var renderFormFields = exports.renderFormFields = function renderFormFields(fields) {
  var fieldsToOmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var sortKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'order';
  return (0, _sortBy2.default)((0, _values2.default)((0, _omit2.default)(fields, fieldsToOmit)), [sortKey]);
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/utils/form/index.js
// module id = 220
// module chunks = 0